import { createContext } from "react";
import { IListContext } from "./../../types/IListContext";

export const ListContext = createContext<IListContext | undefined>(undefined);